import { render, staticRenderFns } from "./activeFiltersBox.vue?vue&type=template&id=143caa80&scoped=true"
import script from "./activeFiltersBox.vue?vue&type=script&lang=js"
export * from "./activeFiltersBox.vue?vue&type=script&lang=js"
import style0 from "./activeFiltersBox.vue?vue&type=style&index=0&id=143caa80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143caa80",
  null
  
)

export default component.exports